import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Component({
	selector: 'app-center-department-ajout-form-modal',
	templateUrl: './center-department-ajout-form-modal.component.html',
	styleUrl: './center-department-ajout-form-modal.component.scss'
})
export class CenterDepartmentAjoutFormModalComponent {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	formAjout = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		description: new FormControl('', Validators.maxLength(255))
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = { value: false };

	centerDepartment: CenterDepartment = new CenterDepartment();

	constructor(public bsModalRef: BsModalRef, private facade: FacadeService) {}

	// ngOnInit(): void {}

	onSubmit() {
		if (this.formAjout.valid) {
			this.isValidateButtonClicked.value = true;
			const userCenter =
				this.facade.dataStorageService.getUser()?.employee.serviceCenter;
			this.centerDepartment.serviceCenter = userCenter;
			this.facade.centerDepartmentService
				.postCenterDepartment(this.centerDepartment)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.response,
							err.status
						);
					}
				});
		}
	}
}
